<h2 mat-dialog-title>{{ data.isNew ? 'Create' : 'Edit' }} Renderer Pool</h2>
<mat-dialog-content>
  <form [formGroup]="form" fxLayout="column" fxLayoutGap="20px">
    <mat-form-field appearance="outline">
      <mat-label>Pool Name</mat-label>
      <input matInput formControlName="name" placeholder="Enter pool name">
      <mat-error *ngIf="form.get('name')?.hasError('required')">
        Name is required
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="loading">Cancel</button>
  <button mat-flat-button color="primary" (click)="save()" 
    [disabled]="form.invalid || loading"
    [class.button-spinner]="loading">
    {{ data.isNew ? 'Create' : 'Update' }}
  </button>
</mat-dialog-actions>